import React, { useEffect, useRef } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

const TrustBox = ({forceMobile = false}): JSX.Element => {
  const microRef = useRef(null)
  const starsRef = useRef(null)

  const matches = useMediaQuery('(min-width:469px)')
  const renderOnceOrOnMatches = forceMobile ? 'null' : matches

  useEffect(() => {
    if (global?.Trustpilot) {
      global.Trustpilot.loadFromElement(starsRef.current, true)
      !(matches && !forceMobile) && global.Trustpilot.loadFromElement(microRef.current, true)
    }
  }, [renderOnceOrOnMatches])

  const renderDesktop = () => (
    <div 
    ref={starsRef}
    style={{ pointerEvents: 'none' }}
    className="trustpilot-widget" 
    data-testid="widget-stars"
    id="tag_header-tp-stars"
    data-locale="en-GB" 
    data-template-id="5419b6ffb0d04a076446a9af" 
    data-businessunit-id="4c5153c900006400050d7636" 
    data-style-height="20px" 
    data-style-width='100%'
    data-theme="light" 
    data-text-color="#333333"
    >  
      <a href="https://uk.trustpilot.com/review/zuto.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  )  

  const renderMobile = () => (
    <>
      <div 
      ref={starsRef}
      className="trustpilot-widget" 
      data-testid="widget-stars-mobile"
      id="tag_header-tp-stars-mobile"
      style={{ margin: '0px auto', display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}
      data-locale="en-GB" 
      data-template-id="5419b6ffb0d04a076446a9af" 
      data-businessunit-id="4c5153c900006400050d7636" 
      data-style-height="20px" 
      data-style-width="320px"
      data-theme="light" 
      data-text-color="#333333"
      >  
        <a href="https://uk.trustpilot.com/review/zuto.com" target="_blank" rel="noopener">Trustpilot</a>
      </div>
      <div 
      ref={microRef}
      style={{ pointerEvents: 'none' }}
      data-testid="widget-micro-mobile"
      id="tag_header-tp-micro-mobile"
      className="trustpilot-widget" 
      data-locale="en-GB" 
      data-template-id="5419b6a8b0d04a076446a9ad" 
      data-businessunit-id="4c5153c900006400050d7636" 
      data-style-height="24px" 
      data-style-width="100%" 
      data-theme="light" 
      data-text-color="#333333" 
      data-style-alignment="center">
        <a href="https://uk.trustpilot.com/review/zuto.com" target="_blank" rel="noopener">Trustpilot</a>
      </div>
    </>
  )  

  

  if (matches && !forceMobile) {
    return renderDesktop()
  }

  return renderMobile()
}

export default TrustBox